import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import Spinner from "../../../components/Spinner"
import relatedContent from './assets/relatedContent.png';
import { getRelatedContent } from "../../../redux/actions/contentPayer"
import { useNavigate } from "react-router-dom";
import './index.css'

export default function RelatedContent({ playerDetails }) {

    const [relatedContentData, setRelatedContentData] = useState(null)
    const [relatedContentSpinner, setRelatedContentSpinner] = useState(false)
    const [error, setError] = useState(false)
    const user_token = useSelector(store => store?.authentication?.user_token)
    const role_type = useSelector(store => store?.userSubscription?.role_type)
    const navigate = useNavigate()

    const dispatch = useDispatch()

    useEffect(() => {
        setRelatedContentSpinner(true)
        dispatch(getRelatedContent(playerDetails['lesson-name'], successObj => {
            setRelatedContentData(successObj)
            setRelatedContentSpinner(false)
        }, errorObj => {
            setError(true)
        }))

        return () => {
            setRelatedContentData(null)
        }
    }, [playerDetails.id])

    return (
        error ?
            <div>
                {
                    role_type === 'basic' ?
                        <div className="flex justify-center items-center flex-col">
                            <h1 className="font-bold text-xl md:text-2xl my-4">This is a premium feature. Please Upgrade to LearnTube Pro to unlock.</h1>
                            <button  className="relatedcontent-background-gradient px-3 py-2 rounded font-bold" onClick={() => navigate('/pricing')}>Upgrade To Pro</button>
                        </div>
                        :
                        <div className="flex justify-center items-center flex-col">
                            <h1 className="font-bold text-xl md:text-2xl my-4">This feature is being updated for a better experience. Please come back later. </h1>
                        </div>
                }
            </div>
            :
            <div className="grid grid-cols-1 md:grid-cols-2">
                {relatedContentData ? relatedContentData.map((item, index) => (
                    <a href={user_token ? item.link : ""} target="_blank" className="flex justify-between items-center bg-slate-300 m-2 md:pr-4 pr-2 rounded cursor-pointer" key={index}>
                        <div className="flex justify-between items-center">
                            <img src={relatedContent} alt="related content image" className="md:w-28 md:h-24 w-20 h-16 object-cover rounded" />
                            <p className="ml-8 md:text-base text-xs">{item.title}</p>
                        </div>
                    </a>
                )) :

                    <Spinner className={"flex justify-center items-center w-full scale-75"} />}
            </div>
    )
}